import {Component, OnInit} from '@angular/core';
import {PopoverRef} from '../popover/popover-ref';
import {TILE_TYPE, TileDef, TileService} from '../../services/tile.service';

@Component({
    selector: 'app-add-tile',
    templateUrl: './add-tile.component.html',
    styleUrls: ['./add-tile.component.scss']
})
export class AddTileComponent implements OnInit {

    currentTiles: TileDef[] = [];

    constructor(public popoverRef: PopoverRef,
                private tilesService: TileService) {
        if (this.popoverRef) {
            this.initializePopoverData();
        }
    }

    ngOnInit() {
        this.initTileList();
    }

    close(): void {
        this.popoverRef.close(null);
    }

    onTileToggle(tile: TileDef) {
        if (tile.selected) {
            return;
        }
        if (tile.type === TILE_TYPE.MVP) {
            this.tilesService.toggleMVPTile(tile.id);
            return;
        }
        this.tilesService.toggleTile(tile);
        this.initTileList();
    }

    private initTileList(): void {
        const currentTiles = this.tilesService.getCurrentTiles();
        const defaultTiles = this.tilesService.getDefaultTiles();

        const tilesWithOriginalKeys = currentTiles.map(currentTile => {
            const defaultTile = defaultTiles.find(dt => dt.type === currentTile.type);
            return {
                ...currentTile,
                title: defaultTile ? defaultTile.title : currentTile.title,
                info: defaultTile ? defaultTile.info : currentTile.info
            };
        });

        this.tilesService.translateTiles(tilesWithOriginalKeys).subscribe(translatedTiles => {
            this.currentTiles = translatedTiles.sort((a, b) => a.addIndex - b.addIndex);
        });
    }

    private initializePopoverData() {
        this.popoverRef.overlay.backdropClick().subscribe(() => {
            this.close();
        });
    }

}


